<template>
  <ion-page>
    <master-layout pageTitle="ویرایش اطلاعات ضایعات">
      <ion-card>
        <ion-card-content>
          <Loading :is="!wastageLoaded" v-if="!wastageLoaded"></Loading>
          <div v-if="wastageLoaded">
            <div v-if="wastage">
              <AjaxForm :route="'wastage/edit/'+wastage._id">
                <div>
                  <label>عنوان</label>
                  <input type="text" name="title" class="form-control" :value="wastage.title">
                </div>
                <div>
                  <label>مقدار</label>
                  <input type="text" name="amount" class="form-control" :value="wastage.amount">
                </div>
                <div>
                  <label>واحد</label>
                  <input type="text" name="unit" class="form-control" :value="wastage.unit">
                </div>
                <ion-button color="success" type="submit" expand="full">ویرایش</ion-button>
              </AjaxForm>
            </div>
            <div v-if="error" class="alert alert-danger">
              {{error}}
            </div>
          </div>
        </ion-card-content>
      </ion-card>
    </master-layout>
  </ion-page>
</template>

<script>
import {
  IonCard, IonCardTitle, IonCardContent, IonPage
} from "@ionic/vue";
import {mapActions} from "vuex";
import Loading from "@/components/Loading";
import AliSelect from "@/components/aliSelect";
import AliAjaxSelect from "@/components/aliAjaxSelect";
import AjaxForm from "@/components/AjaxForm";

export default {
  data()
  {
    return {
      id:null,
      wastageLoaded: false,
      wastage:null,
      error:null,
      carTypeSelected : {}
    };
  },
  async created()
  {
    this.id = this.$route.params.id;
    const result = await this.getAutoWastage(this.id);
    if (result)
    {
      if (result.ok)
      {
        this.wastageLoaded = true;
        this.wastage = result.autoWastage;
      }
      else
      {
        this.wastageLoaded = true;
        this.error = result.error
      }
    }
    else
    {
      this.wastageLoaded = true;
      this.error = 'خطا در برقراری ارتباط با سرور'
    }
  },
  components: {
    AjaxForm,
    Loading,
    AliSelect,
    AliAjaxSelect,
    IonCard, IonCardTitle, IonCardContent, IonPage
  },
  methods: {
    ...mapActions("app", {
      getAutoWastage: 'getAutoWastage'
    }),
  }
};

</script>

<style scoped>
.h5 {
  font-weight: 900;
  font-size: 15px;
  align-self: center;
  color: #000000b3;
}

</style>